import orgHttps from '../init/orgHttps';

//ORG-TRIP-01 : To populate the information on trip organizer dashboard
export async function orgTripdashFun(date, bookingsOnly, limit, offset) {
    const result = await orgHttps.get(
        `/org/trip?date=${date}&bookingsOnly=${bookingsOnly}&limit=${limit}&offset=${offset}`
    );
    return result;
}

//ORG-TRIP-02 : To get complete content of trip for organizer
export async function orgTripDetailsFun(tripId) {
    const result = await orgHttps.get(`/org/trip/packs/${tripId}`);
    return result;
}

//ORG-TRIP-03 : Gives the list of booked customers for given trip
//trip complete booking details for particular date
export async function orgTripBookedFun(tripDateId) {
    const result = await orgHttps.get(`/org/trip/date/booked/${tripDateId}`);
    return result;
}

//ORG-TRIP-04 : Search in organizer page
export async function orgTripSearchFun(text) {
    const result = await orgHttps.get(`/org/trip/search?name=${text}`);
    return result;
}

//ORG-TRIP-05 : Complete details of an organizer
export async function tripOrgInfoFun(type) {
    const result = await orgHttps.get(`/org/${type}/orgInfo`);
    return result;
}

//ORG-TRIP-06 : Create new trip organizer
export async function orgTripRegisterFun(data) {
    const result = await orgHttps.post(`org/trip/register`, data);
    return result;
}

//ORG-TRIP-07 : To add new trip details
export async function tripCreateFun(data) {
    const result = await orgHttps.post(`org/trip/create`, data);
    return result;
}

//ORG-TRIP-08 : To add dates to a trip
export async function tripDateCreateFun(tripId, data) {
    const result = await orgHttps.post(`org/trip/date/${tripId}`, data);
    return result;
}

//ORG-TRIP-09 : To add new booking manually
export async function tripDateMnFun(tripDateId, data) {
    const result = await orgHttps.post(`org/trip/manual/${tripDateId}`, data);
    return result;
}

//ORG-TRIP-10 : To delete the trip with dates and contents
//dont let the trip to be deleted even if it has single booking //it has to be cancalled
//dont let the trip to be delted after completion
export async function tripDeleteFun(tripId) {
    const result = await orgHttps.delete(`org/trip/${tripId}`);
    return result;
}

//ORG-TRIP-11 : To delete a particular dates of the particualr trip
//dont let the trip to be deleted even if it has single booking //it has to be cancalled
//dont let the trip to be delted after completion
export async function tripDateDelete(tripDateId) {
    const result = await orgHttps.delete(`org/trip/trip-date/${tripDateId}`);
    return result;
}

//ORG-TRIP-12 : To get list of pacakages for a particular organizer
export async function tripOrgPackListFun(status, limit, offset, datesType, group, search) {
    const result = await orgHttps.get(
        `/org/trip/packs?status=${status}&limit=${limit}&offset=${offset}&datestype=${datesType}&group=${group}&search=${search}`
    );
    return result;
}

//ORG-TRIP-13 : Getting trip Dates for package
export async function tripOrgDateFun(packId, dateType) {
    const result = await orgHttps.get(`/org/trip/date/${packId}?date=${dateType}`);
    return result;
}

//ORG-TRIP-14 get OTP to register organizer
export async function orgTripRegOTP(data, method) {
    const result = await orgHttps.post(`org/trip/register/otp?method=${method}`, data);
    return result;
}

//ORG-TRIP-15 List of booking for particular organizer,
//Complete list of booking,
//filter will be based on limit, offset, tridId
export async function orgTripBookList(limit, offset, packId, dateId, type, datesType, group) {
    const params = new URLSearchParams({
        packid: packId,
        packdateid: dateId,
        datestype: datesType,
        date: type,
        limit: limit,
        offset: offset
    });

    if (group !== undefined && group !== null) {
        params.append('group', group);
    }

    const result = await orgHttps.get(`org/trip/booked/list?${params.toString()}`);
    return result;
}

//ORG-TRIP-16 List of reviews for particular organizer
//filter will be based on limits, offset, tripId
export async function orgTripReviews(limit, offset, packId) {
    const result = await orgHttps.get(`org/trip/reviews/list?limit=${limit}&offset=${offset}&packId=${packId}`);
    return result;
}

//ORG-TRIP-17 Dropdowns for trip list in page bookings and Reviews
export async function orgTripDrop(datesType, group) {
    const result = await orgHttps.get(`org/trip/packs/list/dropdown?datestype=${datesType}&group=${group}`);
    return result;
}

//ORG-TRIP-18 booking done today
export async function orgTripBookToday() {
    const result = await orgHttps.get(`org/trip/booked/today`);
    return result;
}

//ORG-TRIP-19 dashboard numbers/stats
export async function orgTripDashStats(date) {
    const result = await orgHttps.get(`org/trip/dashboard/stats?date=${date}`);
    return result;
}

//ORG-TRIP-20 account edit
export async function orgAccountEdit(data, type) {
    const result = await orgHttps.patch(`org/${type}/account/edit`, data);
    return result;
}

//ORG-TRIP-21 send message to participant
export async function orgSendMessage(data) {
    const result = await orgHttps.post(`org/trip/send/msg`, data);
    return result;
}

//ORG-TRIP-22 List of billing or payouts for the trip organizer
export async function orgBillings(type, limit, offset, status, approval) {
    const result = await orgHttps.get(
        `org/${type}/billing?limit=${limit}&offset=${offset}&status=${status}&approval=${approval}`
    );
    return result;
}

//ORG-TRIP-23 Edit trip when its active
export async function orgActiveTripEdit(packId, data) {
    const result = await orgHttps.patch(`org/trip/active/${packId}`, data);
    return result;
}

//ORG-TRIP-24 Edit trip when its inactive
export async function orgInactiveTripEdit(packId, data) {
    const result = await orgHttps.put(`org/trip/inactive/${packId}`, data);
    return result;
}

//ORG-TRIP-25 List of payouts for the trip organizer
export async function orgPayouts(limit, offset) {
    const result = await orgHttps.get(`org/trip/payouts?limit=${limit}&offset=${offset}`);
    return result;
}

//ORG-TRIP-26 Details of the trip payout for payout pop-up
export async function orgPayoutsMoreData(id) {
    const result = await orgHttps.get(`org/trip/payout/details/${id}`);
    return result;
}

//ORG-TRIP-27 Count for organizer dashboard
export async function orgDashboardCount(date) {
    const result = await orgHttps.get(`org/trip/dashboard/count?date=${date}`);
    return result;
}

//ORG-TRIP-28 Count packages of particular organizer
export async function orgPackagesCount(status, datesType, group, search) {
    const result = await orgHttps.get(
        `org/trip/packs/list/count?status=${status}&datestype=${datesType}&group=${group}&search=${search}`
    );
    return result;
}

//ORG-TRIP-29 Count of booking for particular organizer
export async function orgBookingCount(packId, dateId, type, datesType, group) {
    const result = await orgHttps.get(
        `org/trip/booked/list/count?&packid=${packId}&packdateid=${dateId}&datestype=${datesType}&group=${group}&date=${type}`
    );
    return result;
}

//ORG-TRIP-30 Count of reviews for particular organizer
export async function orgReviewCount(packId) {
    const result = await orgHttps.get(`org/trip/reviews/list/count?packId=${packId}`);
    return result;
}

//ORG-TRIP-31 Count of billing for the trip organizer
export async function orgBillingCount(type, status, selectedApproval) {
    const result = await orgHttps.get(`org/${type}/billing/count?status=${status}&approval=${selectedApproval}`);
    return result;
}

//ORG-TRIP-32 Count of payouts for the trip organizer
export async function orgPayoutsCount() {
    const result = await orgHttps.get(`org/trip/payouts/count`);
    return result;
}

//ORG-TRIP-33 Cancel the whole trip
export async function orgTripCancelFun(data) {
    const result = await orgHttps.patch(`org/trip/cancel/trip`, data);
    return result;
}

//ORG-TRIP-34 Cancel one booking
export async function orgBookingCancelFun(data) {
    const result = await orgHttps.patch(`org/trip/cancel/each/booking`, data);
    return result;
}

//ORG-TRIP-35 edit slots and rooms
export async function tripDateEditFun(data) {
    const result = await orgHttps.patch(`org/trip/trip-date/slots/edit`, data);
    return result;
}

//ORG-TRIP-36 Stop auto review msg for particular date trip
export async function stopReviewFun(data) {
    const result = await orgHttps.patch(`org/trip/trip-date/review/msg`, data);
    return result;
}

//ORG-TRIP-37 Add unavailable date to trip in custom trips
export async function unavailableDateFun(data, option) {
    const result = await orgHttps.patch(`org/trip/trip/custom/add/unavai/date?option=${option}`, data);
    return result;
}

//ORG-TRIP-38 : Gives the list of booked customers for given trip
//Custom trip complete booking details for particular date
export async function orgCustomTripBookingFun(packid, date) {
    const result = await orgHttps.get(`/org/trip/custom/trip/bookings/${packid}/${date}`);
    return result;
}

//ORG-TRIP-38: To add new booking manually for custom trips
export async function tripDateCustomMnFun(data) {
    const result = await orgHttps.post(`/org/trip/custom/trip/manual/add`, data);
    return result;
}
